import { HttpApiSchema } from "@effect/platform";

/**
 * 429 Too Many Requests
 *
 * Rate limiting has been triggered. The client has sent too many requests
 * in a given amount of time and should retry after a delay.
 *
 * This error type is not provided by @effect/platform's HttpApiError,
 * so we define it here following the same pattern.
 *
 * Use for API rate limiting, Gmail API rate limits, etc.
 *
 * @since 1.0.0
 * @category empty errors
 */
export class TooManyRequests extends HttpApiSchema.EmptyError<TooManyRequests>()(
  { tag: "TooManyRequests", status: 429 },
) {}

/**
 * 422 Unprocessable Entity
 *
 * The request was well-formed but could not be processed due to semantic errors
 * or data integrity issues. Non-retriable — the same request will fail again.
 *
 * Use for internal data inconsistencies (e.g., referenced entity not found
 * when it should exist).
 *
 * @since 1.0.0
 * @category empty errors
 */
export class UnprocessableEntity extends HttpApiSchema.EmptyError<UnprocessableEntity>()(
  { tag: "UnprocessableEntity", status: 422 },
) {}
